import React from "react";
import Subheader from "@components/Subheader/Subheader";
import PageLayout from "@layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

const LANG_BASE = "vessel-call.port-services";

const PortServicesPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";
  return (
    <PageLayout dir={dir}>
      <Subheader
        testId={`port-services-subheader`}
        subtitle={t("navigation.vessel-call")}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{t(`${LANG_BASE}.title`)}</span>
          </div>
        }
      />
      <div className="pt-8 pb-8 px-24 flex flex-col gap-6" data-testid="port-services">
        <Outlet />
      </div>
    </PageLayout>
  );
};

export default PortServicesPage;
